import tagsService from "api/tagsService";
import { IStatus } from "dto/IStatus";
import { ITag } from "dto/ITag";
import moment from "moment";
import {
  MutableRefObject,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useNavigate, useParams } from "react-router-dom";
import { decryptPackage } from "utils/decryptPackage";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

import Chip from "components/Chip";
import CertContext from "contexts/CertContext";
import MenuContext from "contexts/MenuContext";
import PackagesContext from "contexts/PackagesContext";
import { useAuth } from "react-oidc-context";
import sanitizeHtml from "sanitize-html";
import { getUserId } from "utils/getUserId";
import ModalsManagerContext from "contexts/ModalsManager";
import EventContext from "contexts/EventContext";
import GroupIcon from "assets/icons/groups.svg?react";
import classNames from "classnames";
import Popper from "components/Popper";
import { Tooltip } from "@mui/material";
import { useInView } from "framer-motion";
import ChatParticipantsViewModal from "components/ChatParticipantsViewModal";
import Avatar from "components/Avatar";
import ChatMessageSkeleton from "components/ChatMessageSkeleton";
import { removeHtml } from "utils/parseHTML";
import { EStatus } from "components/Avatar/typings";
import { useTranslation } from "react-i18next";

const ChatCard: FC<Props> = ({
  onClick,
  msg,
  statuses, // eslint-disable-line @typescript-eslint/no-unused-vars
  tags, // eslint-disable-line @typescript-eslint/no-unused-vars
  keys,
  isFirst = false, // eslint-disable-line @typescript-eslint/no-unused-vars
  decodedContent, // eslint-disable-line @typescript-eslint/no-unused-vars
  isSelectable = false, // eslint-disable-line @typescript-eslint/no-unused-vars
  selectedElements, // eslint-disable-line @typescript-eslint/no-unused-vars
  setSelectedElements, // eslint-disable-line @typescript-eslint/no-unused-vars
  onPreview, // eslint-disable-line @typescript-eslint/no-unused-vars
  selectMultiple, // eslint-disable-line @typescript-eslint/no-unused-vars
  scrollWrapper,
  showS = true, // eslint-disable-line @typescript-eslint/no-unused-vars
  remove, // eslint-disable-line @typescript-eslint/no-unused-vars
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    filterId, // eslint-disable-line @typescript-eslint/no-unused-vars
    status: linkStatus, // eslint-disable-line @typescript-eslint/no-unused-vars
    chatId,
    threadId, // eslint-disable-line @typescript-eslint/no-unused-vars
    threadPackageId, // eslint-disable-line @typescript-eslint/no-unused-vars
  } = useParams();
  const auth = useAuth();
  const userId = getUserId(auth.user!);

  const isOutcoming = window.location.href.search("outcoming") !== -1; // eslint-disable-line @typescript-eslint/no-unused-vars

  const { mutate: removeTag } = tagsService.useRemoveTagFromPackage(); // eslint-disable-line @typescript-eslint/no-unused-vars
  const [status, setStatus] = useState<IStatus | null>(null); // eslint-disable-line @typescript-eslint/no-unused-vars
  const [findedTags, setFindedTags] = useState<ITag[]>([]); // eslint-disable-line @typescript-eslint/no-unused-vars
  const refWrapper = useRef(null);
  const [showAttach, setShowAttach] = useState(false); // eslint-disable-line @typescript-eslint/no-unused-vars

  const [showEditTags, setShowEditTags] = useState(false); // eslint-disable-line @typescript-eslint/no-unused-vars
  const [showEditStatus, setShowEditStatus] = useState(false); // eslint-disable-line @typescript-eslint/no-unused-vars

  const isSelected = msg?.Id === chatId;
  const receiversReference = useRef();

  // Use object destructuring, so you don't need to remember the exact order
  const inView = useInView(refWrapper, { root: scrollWrapper });

  useEffect(() => {
    if (isSelected && !inView) {
      console.log("Scroll to element");
      refWrapper?.current.scrollIntoView();
    }
  }, [isSelected]);

  const getContent = async () => {
    // typy wiadomości szyfrowanych
    // todo: isEncrypted w IPackage
    if (msg.EncryptionKeyId) {
      try {
        if (!keys) {
          return;
        }

        const encryptionKey = keys.find(
          (key) => key?.Id === msg.EncryptionKeyId
        );

        let parentKey = null;
        if (encryptionKey?.ParentKeyId) {
          parentKey = keys.find(
            (key) => key?.Id === encryptionKey?.ParentKeyId
          );
        }

        let cnt = await decryptPackage(
          userId,
          msg.LastMessage.Content,
          encryptionKey,
          parentKey
        );

        if (cnt) {
          cnt = removeHtml(cnt);
        }

        setContent(cnt);
        setIsDecrypting(false);
        setDecrypted(true);
        return;
      } catch (e) {
        setContent(t("chat.decryptionError"));
        setDecrypted(false);
        setIsDecrypting(false);
        return;
      }
    } else {
      setContent(t("chat.noKey"));
      setIsDecrypting(false);
    }
  };

  useEffect(() => {
    if (msg.LastMessage && !isDecrypting && !decrypted) {
      setIsDecrypting(true);
      getContent();
    }
  }, [keys]);

  // useEffect(() => {
  //   const t = tags?.filter((tag) =>
  //     msg?.TagIds?.find((iTag) => tag.Id === iTag)
  //   );
  //   setFindedTags(t);
  //   const newStatus = statuses?.find((s) => s.Id === msg.StatusId);

  //   setStatus(newStatus ?? null);
  // }, [msg, statuses, msg.StatusId, msg.TagIds]);

  const handleRemoveTag = (tag: ITag) => { // eslint-disable-line @typescript-eslint/no-unused-vars
    // removeTag(
    //   {
    //     OwnerId: msg.Id,
    //     OwnerKind: msg.Kind,
    //     TagId: tag.Id,
    //   },
    //   {
    //     onSuccess: () => {
    //       setFindedTags(findedTags?.filter((ftag) => ftag.Id !== tag.Id));
    //     },
    //   }
    // );
  };

  const handleStatusUpdate = (status?: IStatus) => { // eslint-disable-line @typescript-eslint/no-unused-vars
    setStatus(status);
    setShowEditStatus(false);
  };

  const { packages, setPackages } = useContext(PackagesContext); // eslint-disable-line @typescript-eslint/no-unused-vars
  const [showOptions, setShowOptions] = useState(false); // eslint-disable-line @typescript-eslint/no-unused-vars
  const { id, setId } = useContext(MenuContext); // eslint-disable-line @typescript-eslint/no-unused-vars

  const [showReceivers, setShowReceivers] = useState(false);
  const hasMoreReceivers =
    (msg?.Participants && msg.Participants.length > 2) || msg.Name;
  const [decrypted, setDecrypted] = useState(false);
  const [isDecrypting, setIsDecrypting] = useState(false);
  // useEffect(() => {
  //   if (id !== msg.Id) {
  //     setShowOptions(false);
  //   }
  // }, [id]);

  const { setCert } = useContext(CertContext); // eslint-disable-line @typescript-eslint/no-unused-vars

  const { blockClick } = useContext(EventContext); // eslint-disable-line @typescript-eslint/no-unused-vars

  const handleClick = () => {
    navigate(`/chat/${msg.Id}`);
  };
  const [content, setContent] = useState("");
  const { modals, setModals } = useContext(ModalsManagerContext); // eslint-disable-line @typescript-eslint/no-unused-vars

  const isCurrentDate = moment(msg?.CreationDate ?? msg?.CreationDate).isSame(
    new Date(),
    "day"
  );

  const isTomorrow = moment(msg?.CreationDate ?? msg?.CreationDate).isSame(
    moment(new Date()).subtract(1, "day").startOf("day"),
    "day"
  );

  const isTomorrow_2 = moment(msg?.CreationDate ?? msg?.CreationDate).isSame( // eslint-disable-line @typescript-eslint/no-unused-vars
    moment(new Date()).subtract(2, "day").startOf("day"),
    "day"
  );

  const handleUpdateTags = (tags: ITag[]) => { // eslint-disable-line @typescript-eslint/no-unused-vars
    // let newPackages = [...packages];
    // let el = newPackages.find((c) => c.Id === msg.Id && c.Kind === msg.Kind);
    // if (el) {
    //   el.TagIds = tags.map((t) => t.Id);
    // }
    // setPackages(newPackages);
  };

  const time = msg?.CreationDate ?? new Date();

  // if (listFilter?.type === ETypeOfOrder.CREATION_DATE) {
  //   time = msg.CreationDate;
  // }

  let data = "";

  data = moment(time).format("DD.MM.YY").toString();

  if (isCurrentDate) {
    data = `${t("chat.today")} | ${moment(time).format("HH:mm").toString()}`;
  }

  if (isTomorrow) {
    data = `${t("chat.yesterday")} | ${moment(time).format("HH:mm").toString()}`;
  }

  // useEffect(() => {
  //   if (msg.Id === packageId || msg.Id === threadPackageId) {
  //     setSelectedElements([msg]);
  //   }
  // }, []);

  const [isRightClicked, setIsRightClicked] = useState(false); // eslint-disable-line @typescript-eslint/no-unused-vars
  const [callClose, setCallClose] = useState(false); // eslint-disable-line @typescript-eslint/no-unused-vars

  const [isMouse, setIsMouse] = useState(false);

  const [height, setHeight] = useState("initial"); // eslint-disable-line @typescript-eslint/no-unused-vars
  const contentRef = useRef<HTMLDivElement>(null);
  const [statusPopperRef, setStatusPopperRef] = // eslint-disable-line @typescript-eslint/no-unused-vars
    useState<MutableRefObject<HTMLDivElement>>(null);
  const [tagPopperRef, setTagPopperRef] = // eslint-disable-line @typescript-eslint/no-unused-vars
    useState<MutableRefObject<HTMLDivElement>>(null);
  const iconsRef = useRef<HTMLDivElement>(null); // eslint-disable-line @typescript-eslint/no-unused-vars
  const tagsRef = useRef<HTMLDivElement>(null);

  const createRipple = (event: MouseEvent) => {
    const button = event.currentTarget as HTMLElement;
    const ripple = document.createElement("span");
    const diameter = Math.max(button.clientWidth, button.clientHeight);
    const radius = diameter / 2;

    ripple.style.width = ripple.style.height = `${diameter}px`;
    ripple.style.left = `${event.clientX - button.offsetLeft - radius}px`;
    ripple.style.top = `${event.clientY - button.offsetTop - radius}px`;
    ripple.classList.add(styles.ripple);

    const rippleContainer = button.querySelector(`.${styles.rippleContainer}`);
    rippleContainer?.appendChild(ripple);

    setTimeout(() => {
      ripple.remove();
    }, 600);
  };

  return (
    <div
      ref={contentRef}
      tabIndex={0}
      className={`${styles.msgWrapper} ${isSelected && styles.active_selected}`}
    >
      <div
        data-id={msg.Id}
        onMouseEnter={() => setIsMouse(true)}
        onMouseLeave={() => setIsMouse(false)}
        onContextMenu={(e) => {
          e.preventDefault();
          // handleClickRightButton();
        }}
      >
        <div
          className={`${styles.rippleContainer}`}
          onClick={(e: any) => {
            createRipple(e);
          }}
        >
          <div
            ref={refWrapper}
            onClick={
              onClick
                ? (e: any) => {
                    const ele = e.target.tagName.toLowerCase();
                    const button = e.target.outerHTML.search("button") !== -1;

                    if (ele !== "div" || button) {
                      return;
                    }

                    onClick?.();
                  }
                : handleClick
            }
            className={`${styles.card}`}
          >
            {msg.Unread && (
              <Tooltip title={t("chat.unreadInTicket")}>
                <div className={styles.colorBar}></div>
              </Tooltip>
            )}
            {/* {!msg.Unread && (
              <>
                {isIncoming && !msg.IsIncoming && !msg.IsForwarded && (
                  <div className={styles.directionIcon}>
                    <ReplyIcon />
                  </div>
                )}
                {((isIncoming && !msg.IsIncoming && msg.IsForwarded) ||
                  msg.Pass) && (
                  <div className={styles.directionIcon}>
                    <ForwardIcon />
                  </div>
                )}
              </>
            )} */}
            {/* {msg?.Thread?.Count > 1 && msg?.Thread?.UnreadCount > 0 && (
              <div className={styles.colorBar}>
                {msg?.Thread?.UnreadCount ?? 0}
              </div>
            )} */}
            {/* <div
              style={{ backgroundColor: statusColor }}
              className={styles.statusBar}
            ></div> */}
            <div className={styles.avatar}>
              {msg.Participants.filter((p) => !p.IsMe).length > 0 && (
                <Avatar
                  name={msg.Participants.filter((p) => !p.IsMe)[0].Label}
                  status={
                    msg.Participants.find((x) => !x.IsMe && x.IsOnline)
                      ? EStatus.ONLINE
                      : EStatus.OFFLINE
                  }
                ></Avatar>
              )}
              {msg.Participants.filter((p) => !p.IsMe).length === 0 &&
                msg.Participants.length > 0 && (
                  <Avatar name={msg.Participants[0].Label}></Avatar>
                )}
            </div>
            <div className={styles.content}>
              <div className={`${styles.header}`}>
                <div className={styles.headerWrapper}>
                  {/* <div
                  dangerouslySetInnerHTML={{
                    __html: msg.Number,
                  }}
                  className={styles.sender}
                ></div> */}
                  {msg.Name && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: sanitizeHtml(msg.Name),
                      }}
                      className={styles.title}
                    ></div>
                  )}

                  {msg.Participants &&
                    msg.Participants.filter((p) => !p.IsMe).length === 1 &&
                    !msg.Name &&
                    msg.Participants.filter((p) => !p.IsMe)[0].Label}

                  {hasMoreReceivers && (
                    <div
                      className={classNames(styles.moreReceivers)}
                      ref={receiversReference}
                      onClick={(e) => {
                        setShowReceivers(!showReceivers);
                        e.stopPropagation();
                      }}
                    >
                      <GroupIcon></GroupIcon> + {msg?.Participants?.length ?? 0}
                    </div>
                  )}

                  <Popper
                    open={showReceivers}
                    anchorEl={receiversReference?.current}
                    setOpen={setShowReceivers}
                  >
                    <ChatParticipantsViewModal
                      toggle={() => setShowReceivers(false)}
                      chat={msg}
                    />
                  </Popper>
                </div>
                <div className={styles.dateWrapper}>
                  <div className={styles.date}>{data}</div>
                </div>
              </div>
              {(isDecrypting || decrypted) && (
                <div className={styles.titleWrapper}>
                  {isDecrypting && <ChatMessageSkeleton></ChatMessageSkeleton>}
                  {decrypted && (
                    <>
                      <div className={styles.lead}>
                        {msg?.LastMessage?.SenderLabel}:{" "}
                        <span>{content}</span>
                      </div>
                    </>
                  )}
                </div>
              )}
              <div className={styles.tagRow}>
                <div className={styles.tags} ref={tagsRef}>
                  {findedTags.map((tag) => (
                    <Chip
                      onClick={() => {
                        setTagPopperRef(tagsRef);
                        setShowEditTags(true);
                      }}
                      small
                      outlined={false}
                      element={<>{tag.Name}</>}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`${styles.separator} ${
            !!findedTags.length && styles.sep
          } ${isMouse && styles.hideSep} `}
        ></div>
      </div>

      {/* {showEditStatus && (
        <Popper
          anchorEl={statusPopperRef?.current ?? contentRef?.current}
          open={showEditStatus}
          setOpen={setShowEditStatus}
        >
          <StatusModal
            item={msg}
            toggle={setShowEditStatus}
            selectedStatus={status}
            afterUpdate={handleStatusUpdate}
          />
        </Popper>
      )} */}
      {/* {showEditTags && (
        <Popper
          anchorEl={tagPopperRef?.current ?? contentRef?.current}
          open={showEditTags}
          setOpen={setShowEditTags}
        >
          <ChooseTagNew
            toTag={msg}
            toggle={setShowEditTags}
            updateTags={handleUpdateTags}
            type={TagType.Incoming}
          />
        </Popper>
      )} */}
    </div>
  );
};

export default ChatCard;
